module.exports = {
  no: { human: 'Nein', api: 'no' },
  moduleA: { human: 'Baustein A: Versicherungsschutz bis 10 Tage', api: 'moduleA' },
  moduleB: { human: 'Baustein B: Versicherungsschutz bis 20 Tage', api: 'moduleB' }
}
